import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';

export type UpdateProcedureCategoriesRequest = {
    id: string;
    category?: { name: string; reference: string };
}[];

async function updateProcedureCategories(request: UpdateProcedureCategoriesRequest, templateId: string): Promise<void> {
    const { data } = await api.patch(`/procedures/templates/${templateId}/categories`, request);
    return data;
}

export function useUpdateProcedureCategories(
    templateId: string
): UseMutationResult<void, AxiosError, UpdateProcedureCategoriesRequest, unknown> {
    return useMutation((req) => updateProcedureCategories(req, templateId), {
        onSuccess: () => {
            queryClient.invalidateQueries(['procedures-templates', templateId]);
        },
    });
}
